import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { SectionHeader } from "@/components/SectionHeader";
import { CLUBS } from "@/data/portfolio";

export const Clubs = () => {
  return (
    <section
      id="clubs"
      data-testid="clubs-section"
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32 bg-[#f5f5f5]"
    >
      <SectionHeader
        eyebrow="02 / Clubs & Institutes"
        title="The Pitches I've Called Home"
        description="Every badge tells a story — from the hills of Darjeeling to India's top divisions."
        testId="clubs-header"
      />

      {/* Marquee strip */}
      <div className="mt-12 overflow-hidden border-y border-neutral-200 py-4">
        <div className="flex gap-12 animate-marquee whitespace-nowrap font-display font-black uppercase tracking-tighter text-2xl md:text-3xl text-neutral-300">
          {[...CLUBS, ...CLUBS].map((c, i) => (
            <span key={i} className="flex items-center gap-12">
              {c.name}
              <span className="text-[#e63946]">●</span>
            </span>
          ))}
        </div>
      </div>

      {/* Bento grid */}
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {CLUBS.map((club, idx) => (
          <motion.article
            key={club.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: idx * 0.04, ease: "easeOut" }}
            data-testid={`club-card-${idx}`}
            className="group bg-white border border-neutral-200 p-8 md:p-10 flex flex-col gap-6 hover:border-[#0a0a0a] transition-colors"
          >
            <div className="flex items-start justify-between">
              <span className="inline-flex items-center justify-center w-12 h-12 bg-[#0a0a0a] text-white font-display font-black text-lg group-hover:bg-[#e63946] transition-colors">
                {club.name
                  .split(" ")
                  .map((w) => w[0])
                  .slice(0, 2)
                  .join("")}
              </span>
              <span className="text-[11px] font-semibold uppercase tracking-[0.25em] text-neutral-500">
                {club.period}
              </span>
            </div>

            <div>
              <h3 className="font-display text-2xl font-bold tracking-tight">
                {club.name}
              </h3>
              <p className="mt-1 text-sm font-semibold uppercase tracking-wider text-[#e63946]">
                {club.role}
              </p>
            </div>

            <p className="text-sm text-neutral-600 leading-relaxed">
              {club.note}
            </p>

            <div className="mt-auto pt-6 border-t border-neutral-200 flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 text-xs text-neutral-500">
                <MapPin size={12} />
                {club.location}
              </span>
              <span className="text-xs font-semibold uppercase tracking-wider">
                {club.stats}
              </span>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};
